export var FETCH_ROLE_REQUEST = 'FETCH_ROLE_REQUEST';
export var FETCH_ROLE_SUCCEEDED = 'FETCH_ROLE_SUCCEEDED';
export var FETCH_ROLE_FAILED = 'FETCH_ROLE_FAILED';
export var SET_ROLES = 'SET_ROLES';
